import { SITE } from "@api/constants";
import { request } from "@api/graphql";
import activateLicense2Mutation from "@api/mutations/activate-license-2";

type LicenseAttributeInput = {
  code: string;
  value: string;
};

type LicensablePayload = {
  licensable?: Licensable;
  statusCode: number;
  reason: LicensableReasonPayload;
};

type LicensableReasonPayload = {
  key: string;
  value: string;
};

type Licensable = {
  id: string;
  type: string;
  customerId: string;
  courses: CourseLicense[];
};

type CourseLicense = {
  courseSku: string;
  courseName: string;
};

type MutationResult = {
  data: {
    activateLicense2: LicensablePayload;
  };
};

const activateLicense2 = async (
  token: string,
  id: string,
  attributes: LicenseAttributeInput[]
): Promise<LicensablePayload> => {
  const response = await request({
    query: activateLicense2Mutation,
    variables: {
      id,
      accountId: SITE,
      attributes,
    },
    token,
  });

  console.log(response);
  const responseBody = (await response.json()) as MutationResult;
  return responseBody?.data.activateLicense2;
};

export default activateLicense2;
